import { useState, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions, auth } from '../lib/firebase';

interface UserAppRolesRequest {
  uid: string;
  appId: string;
}

export interface UserRole {
  id: string;
  role_key: string;
  role_name: string;
  description: string;
  permissions: Record<string, unknown>;
  assigned_at: Record<string, unknown>;
  assigned_by: string;
}

export const useUserAppRoles = () => {
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUserAppRoles = useCallback(async (appId: string): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }

      const adminGetUserAppRoles = httpsCallable<UserAppRolesRequest, UserRole[]>(functions, 'adminGetUserAppRoles');

      const result = await adminGetUserAppRoles({
        uid: user.uid,
        appId,
      });

      setRoles(Array.isArray(result.data) ? result.data : []);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      setError(errorMessage);
      setRoles([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    roles,
    loading,
    error,
    fetchUserAppRoles,
  };
};
